import React from 'react';
import { DragSource } from 'react-dnd';
import cx from 'classnames';
import _ from 'lodash';
import { Form, Col, Button } from 'react-bootstrap';
import { DragIndicator } from '@material-ui/icons';
import { displayValue } from "../../utils/RequestUtils";
import JobUtils, { getProcessingLabel, getValue } from "../../utils/JobsUtils";
import './dragdrop.scss';
import styles from "../../styles/_export.modules.scss";

const PROCESSING_FIELDS = ["addBurnInTC", "watermark", "notes"];
const regexPattern = new RegExp(/[^a-zA-Z0-9-_. ]/g); 
    
const dragHandler = {
    canDrag: function (props) {
        if(JobUtils.skipValidationByJobType(props.jobType) && !props.novalidation) {
            if (regexPattern.test(props.title) && !props.isNoDelivery){
                props.onDragPrevent();
            }
            return props.canDrag && !regexPattern.test(props.title);
        }else {
            return props.canDrag
        }
    },
    beginDrag: function (props) {
        return {
            data: props.data,
            process: props.process,
        };
    },
};

function collect(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    };
}

class DraggableItem extends React.Component {
    parseFileName(fullName) {
        const name = fullName ?? "";
        const lastDotIdx = name.lastIndexOf(".");
        if (lastDotIdx > 0 && lastDotIdx < name.length - 1) {
            return {
                title: name.slice(0, lastDotIdx),
                ext: name.slice(lastDotIdx + 1),
            };
        }
        return { title: name, ext: "" };
    }

    getInitialState = () => {
        if (this.props.title) {
            const fileDetails = this.parseFileName(this.props.title);

            return {
                title: fileDetails.title,
                isEditing: false,
                errors: false,
                ext: fileDetails.ext,
            };
        } else {
            return {};
        }
    }

    state = this.getInitialState();

    componentWillReceiveProps(nextProps) {
        // improve this condition
        try {
            const fileDetails = this.parseFileName(nextProps.title);
            this.setState({
                title: fileDetails.title,
                isEditing: false,
                errors: false,
                ext: fileDetails.ext,
            });
        } catch (e) { }
    }

    renderForm() {
        const isUploadTechwood = this.props.jobType === "UPLOAD_ONLY" && this.props.sourceLocation === "TECHWOOD";
        const isCustomSpec =
            _.get(this.props, "process.fileType") === "Custom";
        const fileRegExStr = (isUploadTechwood || isCustomSpec) ? "^[a-zA-Z0-9_.-]*$" : "^[a-zA-Z0-9_-]*$";
        const extension = !_.isEmpty(this.state.ext) ? "." + this.state.ext : "";
        const renderFilename = (isUploadTechwood || isCustomSpec) ? this.state.title + extension : this.state.title;
        return (
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const updatedFileName = e.target["fileName"].value;
                    if (isCustomSpec) {
                        const parsed = this.parseFileName(updatedFileName);
                        this.setState({ title: parsed.title, ext: parsed.ext, isEditing: false }, () => {
                            this.props.onFileNameUpdated(updatedFileName);
                        });
                    } else {
                        const finalFileName = _.isEmpty(this.state.ext) || isUploadTechwood ? updatedFileName : updatedFileName + "." + this.state.ext;
                        this.setState({ title: updatedFileName, isEditing: false }, () => {
                            this.props.onFileNameUpdated(finalFileName);
                        });
                    }
                }}>
                <Form.Row className="formRow">
                    <Col xs={12} className="formCol">
                        <Form.Label htmlFor="fileName" srOnly>
                            File Name
                        </Form.Label>
                        <Form.Control
                            className="formInput formInvalidCustom"
                            id="fileName"
                            defaultValue={renderFilename}
                            onInvalid={(e) => {
                                e.target.setCustomValidity("Please revise the filename to remove invalid characters.")
                            }}
                            onChange={(e) => { e.target.setCustomValidity('') }}
                            pattern={fileRegExStr} //Validation added to accept only characters
                        />
                    </Col>
                </Form.Row>
                <Form.Row className="formButtonRow">
                    <Col xs="auto" className="formCol">
                        <Button type="submit"
                            className="formButton">
                            Save
                        </Button>
                    </Col>
                    <Col xs="auto" className="formCol">
                        <Button
                            className="formButton"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.setState({ isEditing: false });
                            }}>
                            Cancel
                        </Button>
                    </Col>
                </Form.Row>
            </Form>
        );
    }

    render() {
        let isDragging = this.props.isDragging;
        let connectDragSource = this.props.connectDragSource;
        let connectDragPreview = this.props.connectDragPreview;
        let isEditing = this.state.isEditing;
        let isUnMapped = this.props.isUnMapped;
        let isMapped = this.props.isMapped;
        let process = this.props.process;
        let processFields = this.props.processFields;
        let jobType = this.props.jobType;
        let itemClasses = cx({
            "drag-item": true,
            dragging: isDragging,
        });
        let itemClassesForm = cx({
            "drag-item": false,
            dragging: false,
            "dragItemContainer": true,
            "extraPadding": true,
        });

        return connectDragSource(
            connectDragPreview(
                isEditing ? (
                    <div
                        className={itemClassesForm}>
                        {this.renderForm()}
                    </div>
                ) : (
                    <div
                        className= {"dragItemContainer "+(this.props.title && (this.props.title.match(regexPattern) || /(?:^\s+)|(?:\s+$)/g.test(this.props.title)) && 
                        (JobUtils.skipValidationByJobType(this.props.jobType) && !this.props.novalidation)?'dragItemContainer-invalid':'')}
                        style={{
                            backgroundColor: !this.props.canDrag ? styles.disabledLightColor : "",
                            cursor: !this.props.canDrag ? "" : isDragging ? "grabbing" : "grab",
                            opacity: isDragging ? 0.6 : 1,
                        }}>
                        <div>

                            {!this.props.nonEditable && (
                                <Button
                                    className="dragItemButton"
                                    hidden={jobType === "EVENT_SCREENERS" || jobType === "VIP_PRE_AIR"}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        this.setState({ isEditing: true });
                                    }}>
                                    <i
                                        className="material-icons verticalAlignMiddle">
                                        mode_edit
                                    </i>
                                    Rename
                                </Button>
                            )}
                            <DragIndicator className="dragIndicator" />
                        </div>
                        <div
                            style={{
                                overflowY: "scroll",
                                padding: this.props.noPadding ? "" : "10px 15px"
                            }}>
                            <div className={itemClasses} style={{
                                height: this.props.noPadding ? "" : "30px",
                            }}>
                                {_.isEmpty(this.props.children) ? (
                                    <>
                                        <label
                                            className="titleLabel"
                                            style={{
                                                color: this.props.isError ? 'red' : isMapped ? styles.colorDarkBlue : isUnMapped ? styles.colorRed : styles.colorBlack,
                                                cursor: !this.props.canDrag ? "" : isDragging ? "grabbing" : "grab",
                                            }}>
                                            {_.isEmpty(process)
                                                ? !_.isEmpty(this.state.ext)
                                                    ? this.state.title + "." + this.state.ext
                                                    : this.state.title
                                                : !_.isEmpty(this.state.ext)
                                                    ? this.state.title + "." + this.state.ext + displayValue(processFields, process)
                                                    : this.state.title + displayValue(processFields, process)}
                                        </label>
                                    </>
                                ) : (
                                    this.props.children
                                )}
                            </div>
                            {process && jobType === "FILE_CREATION" ? (
                                _.map(PROCESSING_FIELDS, (fieldName, index) => {
                                    return (process[fieldName] ?
                                        (<div
                                            key={fieldName + index}>
                                            <span className="infoMore">
                                                {getProcessingLabel(jobType, fieldName)}:
                                            </span>
                                            <span className="info">
                                                {getValue(fieldName, process[fieldName])}
                                            </span>
                                        </div>) : null);
                                })
                            ) : null}
                        </div>
                    </div>
                ), { captureDraggingState: true }
            )
        )
    }
}

export default DragSource("source", dragHandler, collect)(DraggableItem);